import { render, staticRenderFns } from "./integral-change.vue?vue&type=template&id=0329478d&scoped=true&"
import script from "./integral-change.vue?vue&type=script&lang=js&"
export * from "./integral-change.vue?vue&type=script&lang=js&"
import style0 from "./integral-change.vue?vue&type=style&index=0&id=0329478d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0329478d",
  null
  
)

export default component.exports